<template>
  <div>
    <b-form-group class="mt-4">
      <slot></slot>
      <b-form-select v-model="column_index" :options="columns_options" />
    </b-form-group>
    <b-form-group v-if="column_index == -1">
      <label>
        <b> {{ $t('colname_wanted') }} </b>
      </label>
      <b-row>
        <b-col cols="10">
          <b-input-group>
            <b-input-group-prepend>
              <b-button
                v-if="!current_manual_contains_metavariables"
                :variant="metavariables_button_variant"
                @click="
                  current_manual_contains_metavariables = !current_manual_contains_metavariables
                "
              >
                <span class="fas fa-brackets-curly" />
              </b-button>
            </b-input-group-prepend>
            <b-form-input
              v-model="manual_colname"
              :placeholder="$t('enter_colname')"
            />
          </b-input-group>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
import _ from 'lodash'

import { GenericColumnName } from '@/components/object_model.js'

// *****************************************************************************

export default {
  name: 'SelectOneColumn',
  props: ['available_columns', 'value'],
  data() {
    return {
      column_index: -2,
      manual_colname: '',
      current_manual_contains_metavariables: false,
    }
  },

  computed: {
    columns_options() {
      let options = [
        { value: -2, text: this.$t('choose_a_column') },
        { value: -1, text: this.$t('enter_manual_column') },
      ]
      _.forEach(this.available_columns || {}, function(x, ind) {
        options.push({ value: ind, text: x })
      })

      return options
    },

    local_value() {
      let res
      let name = this.available_columns[this.column_index]
      if (this.column_index === -2) {
        res = null
      } else if (this.column_index === -1) {
        res = new GenericColumnName(
          this.manual_colname,
          this.current_manual_contains_metavariables
        )
      } else {
        res = new GenericColumnName(name, false)
      }
      return res
    },

    metavariables_button_variant() {
      let res
      if (this.current_manual_contains_metavariables) {
        res = 'secondary'
      } else {
        res = 'outline-secondary'
      }

      return res
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, this.local_value)) {
          this.destructure()
        }
      },
    },
    available_columns: {
      immediate: true,
      handler(nv, ov) {
        this.destructure()
      },
    },

    local_value(nv, ov) {
      if (!_.isEqual(nv, ov)) {
        this.$emit('updated_value', nv)
      }
    },
  },
  methods: {
    destructure() {
      if (_.isNull(this.value)) {
        this.column_index = -2
      } else if (this.value.contains_metavariables) {
        this.current_manual_contains_metavariables = true
        this.column_index = -1
        this.manual_colname = this.value.name
      } else {
        let index = _.indexOf(this.available_columns, this.value.name)
        this.current_manual_contains_metavariables = false
        this.column_index = index
        if (index === -1) {
          this.manual_colname = this.value.name
        }
      }
    },
  },
}
</script>
